const FILE_FORMATS = {
  'pagos-recaudacion': {
    name: 'Pagos y Recaudación',
    description: 'Formato estándar para importación de pagos',
    lineLengthDetails: 749, // Detalles mayores o igual
    lineLengthHeader: 33,
    header: [
      {
        name: 'tipo',
        position: 1, // Posición inicial (1-based)
        length: 1, // Cantidad de caracteres
        type: 'string',
        required: true,
        description: 'Identificación del registro encabezado',
      },
      {
        name: 'identificacion',
        position: 2,
        length: 10,
        type: 'string',
        required: true,
        description: 'Nombre del Grupo de Deudas',
      },
      {
        name: 'fecha_proceso',
        position: 12,
        length: 8,
        type: 'date',
        format: 'YYYYMMDD',
        required: true,
        description: 'Fecha de generación del archivo',
      },
      {
        name: 'hora_proceso',
        position: 20,
        length: 6,
        type: 'number',
        required: true,
        description: 'Hora de generación del archivo',
      },
      {
        name: 'nro_archivo_enviado',
        position: 26,
        length: 4,
        type: 'string',
        required: true,
        description: 'Identificación del registro',
      },
      {
        name: 'numero_archivo_recibido',
        position: 30,
        length: 4,
        type: 'number',
        required: false,
        description: 'Nro. identificador del archivo recibido',
      },
    ],
    fields: [
      {
        name: 'tipo',
        position: 1,
        length: 1,
        type: 'string',
        required: true,
        description: 'Identificación del registro encabezado',
      },
      {
        name: 'codigo_servicio',
        position: 2,
        length: 4,
        type: 'number',
        required: true,
        description: 'Código provisto por el banco',
      },
      {
        name: 'codigo_deudor',
        position: 6,
        length: 18,
        type: 'number',
        required: true,
        description: 'Código que identifica al Deudor o Cliente en la Empresa',
      },
      {
        name: 'nro_comprobante',
        position: 24,
        length: 18,
        type: 'string',
        required: true,
        description: 'Nro. de Comprobante',
      },
      {
        name: 'tipo_documento_deudor',
        position: 42,
        length: 2,
        type: 'number',
        required: true,
        description: 'Tipo de Documento del Deudor',
      },
      {
        name: 'nro_documento_deudor',
        position: 44,
        length: 13,
        type: 'number',
        required: true,
        description: 'Nro. de CUIT/CUIL o D.N.I. del Deudor',
      },
      {
        name: 'fecha_origen_deuda',
        position: 57,
        length: 8,
        type: 'date',
        format: 'YYYYMMDD',
        required: true,
        description: 'Fecha de origen de la Deuda',
      },
      {
        name: 'fecha_vigencia_deuda',
        position: 65,
        length: 8,
        type: 'date',
        format: 'YYYYMMDD',
        required: true,
        description: 'Fecha de caducidad de la Deuda',
      },
      {
        name: 'importe_1er_vencimiento',
        position: 73,
        length: 15,
        type: 'decimal',
        decimals: 2,
        required: true,
        description: 'Importe a pagar hasta el 1er. Vencimiento indicado',
      },
      {
        name: 'fecha_1er_vencimiento',
        position: 88,
        length: 8,
        type: 'date',
        format: 'YYYYMMDD',
        required: true,
        description: 'Fecha del 1er. Vencimiento del pago',
      },
      {
        name: 'importe_2do_vencimiento',
        position: 96,
        length: 15,
        type: 'decimal',
        decimals: 2,
        required: false,
        description: 'Importe a pagar después del 1er. Vencimiento',
      },
      {
        name: 'fecha_2do_vencimiento',
        position: 111,
        length: 8,
        type: 'date',
        format: 'YYYYMMDD',
        required: false,
        description: 'Fecha del 2do. Vencimiento',
      },
      {
        name: 'importe_3er_vencimiento',
        position: 119,
        length: 15,
        type: 'decimal',
        decimals: 2,
        required: false,
        description: 'Importe a pagar después del 2do. Vencimiento',
      },
      {
        name: 'fecha_3er_vencimiento',
        position: 134,
        length: 8,
        type: 'date',
        format: 'YYYYMMDD',
        required: false,
        description: 'Fecha del 3er. Vencimiento',
      },
      {
        name: 'nombre_deudor',
        position: 142,
        length: 30,
        type: 'string',
        required: true,
        description: 'Apellido y nombre o Razón Social del Deudor',
      },
      {
        name: 'identificacion_deuda',
        position: 172,
        length: 30,
        type: 'string',
        required: true,
        description: 'Código/Número que identifica a esta Deuda',
      },
      {
        name: 'area_division_origen',
        position: 202,
        length: 6,
        type: 'string',
        required: false,
        description: 'Código o Número del Área, División, Sucursal o Centro de Costo',
      },
      {
        name: 'nombre_area_origen',
        position: 208,
        length: 30,
        type: 'string',
        required: false,
        description: 'Nombre del Área, División, Sucursal o Centro de Costo originante',
      },
      {
        name: 'codigo_moneda',
        position: 238,
        length: 2,
        type: 'string',
        required: true,
        description: 'Moneda de la Deuda',
      },
      {
        name: 'cuit_empresa_origen',
        position: 240,
        length: 11,
        type: 'string',
        required: false,
        description: 'Nro. de CUIT de la Empresa, División o Subsidiaria',
      },
      {
        name: 'leyenda_1',
        position: 251,
        length: 38,
        type: 'string',
        required: false,
        description: 'Leyenda 1',
      },
      {
        name: 'leyenda_2',
        position: 289,
        length: 38,
        type: 'string',
        required: false,
        description: 'Leyenda 2',
      },
      {
        name: 'leyenda_3',
        position: 327,
        length: 38,
        type: 'string',
        required: false,
        description: 'Leyenda 3',
      },
      {
        name: 'leyenda_4',
        position: 365,
        length: 38,
        type: 'string',
        required: false,
        description: 'Leyenda 4',
      },
      {
        name: 'leyenda_5',
        position: 403,
        length: 38,
        type: 'string',
        required: false,
        description: 'Leyenda 5',
      },
      {
        name: 'leyenda_6',
        position: 441,
        length: 38,
        type: 'string',
        required: false,
        description: 'Leyenda 6',
      },
      {
        name: 'leyenda_7',
        position: 479,
        length: 38,
        type: 'string',
        required: false,
        description: 'Leyenda 7',
      },
      {
        name: 'leyenda_8',
        position: 517,
        length: 38,
        type: 'string',
        required: false,
        description: 'Leyenda 8',
      },
      {
        name: 'leyenda_9',
        position: 555,
        length: 38,
        type: 'string',
        required: false,
        description: 'Leyenda 9',
      },
      {
        name: 'leyenda_10',
        position: 593,
        length: 38,
        type: 'string',
        required: false,
        description: 'Leyenda 10',
      },
      {
        name: 'fecha_pago',
        position: 631,
        length: 8,
        type: 'date',
        format: 'YYYYMMDD',
        required: false,
        description: 'Fecha de Pago',
      },
      {
        name: 'sucursal_cobro',
        position: 639,
        length: 3,
        type: 'number',
        required: true,
        description: 'Sucursal de cobro',
      },
      {
        name: 'forma_medio_pago',
        position: 642,
        length: 1,
        type: 'number',
        required: true,
        description: 'Forma/Medio de pago',
      },
      {
        name: 'nro_secuencial_pago',
        position: 643,
        length: 10,
        type: 'number',
        required: true,
        description: 'Nro. Secuencial de Pago',
      },
      {
        name: 'cajero',
        position: 653,
        length: 10,
        type: 'string',
        required: true,
        description: 'Cajero',
      },
      // {
      //   name: 'hora_pago',
      //   position: 663,
      //   length: 6,
      //   type: 'number',
      //   required: true,
      //   description: 'Hora de pago',
      // },
      // {
      //   name: 'relleno1',
      //   position: 669,
      //   length: 2,
      //   type: 'string',
      //   required: true,
      //   description: 'RELLENO',
      // },
      {
        name: 'pago_parcial',
        position: 673,
        length: 1,
        type: 'string',
        required: true,
        description: 'Pago parcial',
      },
      {
        name: 'importe_pagado',
        position: 674,
        length: 15,
        type: 'number',
        required: true,
        decimals: 2,
        description: 'Importe pagado',
      },
      {
        name: 'fecha_vencimiento',
        position: 689,
        length: 8,
        type: 'date',
        format: 'YYYYMMDD',
        required: false,
        description: 'Fecha de Vencimiento',
      },
      {
        name: 'numero_cheque',
        position: 697,
        length: 8,
        type: 'number',
        required: false,
        description: 'Número de Cheque',
      },
      {
        name: 'banco_emisor',
        position: 705,
        length: 3,
        type: 'number',
        required: false,
        description: 'Banco Emisor',
      },
      {
        name: 'sucursal_banco_emisor',
        position: 708,
        length: 4,
        type: 'number',
        required: false,
        description: 'Sucursal Banco Emisor',
      },
      {
        name: 'codigo_postal',
        position: 712,
        length: 7,
        type: 'string',
        required: false,
        description: 'Código Postal',
      },
      {
        name: 'fecha_present_cheque',
        position: 719,
        length: 8,
        type: 'date',
        format: 'YYYYMMDD',
        required: false,
        description: 'Fecha Present Cheque',
      },
      {
        name: 'cuit_emisor_cheque',
        position: 727,
        length: 11,
        type: 'false',
        required: false,
        description: 'Cuit Emisor Cheque',
      },
      {
        name: 'cuenta_emisor_cheque',
        position: 738,
        length: 11,
        type: 'number',
        required: false,
        description: 'Cuenta Emisor Cheque',
      },
      {
        name: 'estado_cheque',
        position: 749,
        length: 1,
        type: 'string',
        required: false,
        description: 'Estado cheque',
      },
      {
        name: 'motivo_rechazo_negociacion',
        position: 750,
        length: 10,
        type: 'string',
        required: false,
        description: 'Motivo de rechazo/Negociación',
      },
      {
        name: 'canal_pago',
        position: 760,
        length: 2,
        type: 'string',
        required: true,
        description: 'Canal del pago',
      },
      {
        name: 'nro_transaccion_cobranza',
        position: 762,
        length: 10,
        type: 'number',
        required: true,
        description: 'Nro. de Transacción cobranza',
      },
      {
        name: 'fecha_ingreso',
        position: 772,
        length: 8,
        type: 'date',
        format: 'YYYYMMDD',
        required: true,
        description: 'Fecha de Ingreso',
      },
      {
        name: 'fecha_imputacion',
        position: 780,
        length: 8,
        type: 'date',
        format: 'YYYYMMDD',
        required: true,
        description: 'Fecha de Imputación',
      },
      // {
      //   name: 'relleno2',
      //   position: 772,
      //   length: 63,
      //   type: 'string',
      //   required: true,
      //   description: 'RELLENO',
      // },
    ],
  },
};

export { FILE_FORMATS };
